import React from "react";
import TXT from "presentational/common/multinational/TXT";
import LoadingView from "presentational/common/LoadingView";
import ItemUnitListView from "presentational/common/itemUnit/ItemUnitListView";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import { getDeviceType } from "lib/deviceInfo";
import config from "lib/fr-config";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const mobileCss = config.css.mobile;
const desktopCss = config.css.desktop;
const fontCss = config.css.fontThickness;

const cssXS = {
  itemListArea: {
    marginBottom: mobileCss.standardPaddingBetweenContent
  },
  sectionTitleWrapper: {
    paddingBottom: mobileCss.sectionTitleBottomPadding,
    display: "flex",
    justifyContent: "flex-end"
  },
  itemListWrapper: { marginBottom: 40 },
  logInRecommentBtnWrapper: { display: "flex", justifyContent: "center" },
  linkItemBtnWrapper: { display: "flex", justifyContent: "center" }
};

const cssXL = {
  itemListArea: {
    marginBottom: desktopCss.standardPaddingBetweenContent
  },
  sectionTitleWrapper: {
    paddingBottom: desktopCss.sectionTitleBottomPadding,
    display: "flex",
    justifyContent: "flex-end"
  },
  itemListWrapper: { marginBottom: 40 },
  logInRecommentBtnWrapper: { display: "flex", justifyContent: "center" },
  linkItemBtnWrapper: { display: "flex", justifyContent: "center" }
};

const TitleTypography = withStyles({
  root: {
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.sectionTitleFontSizePX
        : desktopCss.sectionTitleFontSizePX,
    fontWeight: fontCss.bold,
    lineHeight: 1
  }
})(Typography);

OutfitDetailItemView.propTypes = {
  itemData: PropTypes.array,
  typeOfUser: PropTypes.oneOf(["pending", "owner", "others", "guest"])
    .isRequired,
  onItemClick: PropTypes.func.isRequired,
  onEditModeSelect: PropTypes.func.isRequired,
  onLogInRecommendationButtonClick: PropTypes.func.isRequired
};

function OutfitDetailItemView(props) {
  const {
    itemData,
    typeOfUser,
    onItemClick,
    onEditModeSelect,
    onLogInRecommendationButtonClick
  } = props;

  const deviceType = getDeviceType();
  const css = deviceType === "mobile" ? cssXS : cssXL;

  return (
    <div style={css.itemListArea}>
      <div style={css.sectionTitleWrapper}>
        <TitleTypography>
          <TXT name="titleSection_items" />
        </TitleTypography>
      </div>
      {!itemData ? (
        <div style={css.itemListWrapper}>
          <LoadingView />
        </div>
      ) : (
        itemData.length > 0 && (
          <div style={css.itemListWrapper}>
            <ItemUnitListView
              itemList={itemData}
              onItemClick={onItemClick}
              displayTooltip
            />
          </div>
        )
      )}
      {typeOfUser === "guest" && (
        <div style={css.logInRecommentBtnWrapper}>
          <ContainedCommonButtonView
            onClick={onLogInRecommendationButtonClick({
              type: "logInRecommendationBtn",
              loc: "outfitPage-item"
            })}
          >
            <TXT name="btnCommonContained_loginRecommend" />
          </ContainedCommonButtonView>
        </div>
      )}
      {typeOfUser === "owner" && !!itemData && itemData.length === 0 && (
        <div style={css.linkItemBtnWrapper}>
          <ContainedCommonButtonView onClick={onEditModeSelect}>
            <TXT name="btnCommonContained_linkItems" />
          </ContainedCommonButtonView>
        </div>
      )}
    </div>
  );
}

export default OutfitDetailItemView;
